import { render, staticRenderFns } from "./getFollowView.vue?vue&type=template&id=3b7d2a2b&scoped=true&"
import script from "./getFollowView.vue?vue&type=script&lang=js&"
export * from "./getFollowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d2a2b",
  null
  
)

export default component.exports